import CurrencyEntity from "../Entities/CurrencyEntity";
import OpportunityEntity from "../Entities/OpportunityEntity";
import Network from "../network/network";
import DateTime from "../util/DateTime";
import BaseModel from "../viewModels/BaseModel";

const STATE_KEYS: Record<string, string> = {
    State1: "opportunity-state-1",
    State2: "opportunity-state-2",
    State3: "opportunity-state-3",
    State4: "opportunity-state-4",
    State5: "opportunity-state-5",
};

const OVERALL_STATE_KEYS: Record<string, string> = {
    None: "opportunity-overall-open",
    Won: "opportunity-overall-won",
    Loss: "opportunity-overall-lost",
    Neutral: "opportunity-overall-neutral",
};

export default class OpportunityModel extends kendo.data.ObservableObject {
    private readonly _opportunity: OpportunityEntity;
    private readonly _currencies: CurrencyEntity[];
    private _avatar: string;
    private _detailVisible: boolean;

    constructor(opportunity: OpportunityEntity, currencies: CurrencyEntity[]) {
        super();
        this._opportunity = opportunity;
        this._currencies = currencies;
        super.init(this);
    }

    get Id(): number {
        return this._opportunity.Id;
    }

    get Avatar(): string {
        return this._avatar;
    }

    set Avatar(val: string) {
        this._avatar = val;
    }

    get Title(): string {
        return this._opportunity.Titel;
    }

    get DisplayTitle(): string {
        return this.Title.length > 36 ? this.Title.substr(0, 36) + "..." : this.Title;
    }

    get OrphyOpportunityLink(): string {
        return `${Network.BaseURL}OpportunityDetail/Details/${this._opportunity.Id}`;
    }

    get HasPerson(): boolean {
        return !!this._opportunity.Person;
    }

    get HasInstitution(): boolean {
        return !!this._opportunity.Institution;
    }

    get PersonName(): string {
        return this._opportunity.Person?.DisplayName;
    }

    get HasDueDate(): boolean {
        return !!this._opportunity.DueDate;
    }

    get DueDate(): string {
        return DateTime.parseNumberDate(new Date(this._opportunity.DueDate));
    }

    get OrphyPersonLink(): string {
        return `${Network.BaseURL}PersonDetail/Details/${this._opportunity.Person?.Id}`;
    }

    get Price(): string {
        return `${this._opportunity.Price} ${this._currencies.find(c => c.Id === this._opportunity.CurrencyId).Symbol}`;
    }

    get ContactPersonName(): string {
        return this._opportunity.ContactPerson.DisplayName;
    }

    get ContactPersonLink(): string {
        return `${Network.BaseURL}PersonDetail/Details/${this._opportunity.ContactPerson.Id}`;
    }

    get InstitutionName(): string {
        return this._opportunity.Institution?.Name;
    }

    get OrphyInstitutionLink(): string {
        return `${Network.BaseURL}InstitutionDetail/Details/${this._opportunity.Institution?.Id}`;
    }

    get OverAllState(): string {
        const key = OVERALL_STATE_KEYS[this._opportunity.OverallState];
        return key ? BaseModel.t(key) : "";
    }

    get State(): string {
        const key = STATE_KEYS[this._opportunity.State];
        return key ? BaseModel.t(key) : "";
    }

    get DetailVisible(): boolean {
        return this._detailVisible;
    }

    set DetailVisible(val: boolean) {
        this._detailVisible = val;
    }

    public toggleDetail = e => {
        this.set("DetailVisible", !this.get("DetailVisible"));
    };
}
